<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

import Profile from "@/components/widgets/profile";
import Earning from "@/components/widgets/earning";
import Stat from "@/components/widgets/stat";
import Transaction from "@/components/widgets/transaction";
import Emailsent from "@/components/widgets/emailsent";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {

  },
  data() {
    return {
      title: "Ditujukan untuk",
      items: [
        {
          text: "Dashboards",
          href: "/"
        },
        {
          text: "Default",
          active: true
        }
      ],
    };
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

  <nav class="navbar navbar-expand-lg navigation sticky" id="navbar">
    <div class="container">
      <a class="navbar-logo" href="/">
        <img src="@/assets/images/gurukreator.png" alt="paideia education solution" height="40" margin-top="10" class="logo logo-dark" />
        <img src="@/assets/images/gurukreator.png" alt="paideia education solution" height="40" margin-top="10" class="logo logo-light" />
      </a>
    </div>
  </nav>

  <div class="text-center mt-5">
    <b-button-group style="width:280px;">
            <b-button class="mb-5 mr-1" style="background-color: #00AFEF; border-style:none;" variant="primary rounded-pill">Pribadi</b-button> 
            <b-button class="mb-5 ml-1" style="background-color: #00AFEF; border-style:none" variant="primary rounded-pill">Donatur</b-button> 
    </b-button-group>
  </div>

    <div class="row">
      <div class="col-xl-4">
        <div class="card"
              style= "
                      border-radius: 8px;
                      box-shadow: 1px 2px 8px rgba(0, 0, 0, 0.10);
                      margin: 0rem 1rem 1rem 1rem;
                      height: 280px;
                    "              
        >
          <div class="card-body">
             <h5 style="margin-left:10px; color:#373334" class="ml-4">Monthly</h5>
             <p style="color:#c6c6c6" class="ml-4">Mulai dari <span class="blue-paideia"><b>20.000</b></span> / bulan</p>
             <p style="color:#373334" class="ml-4">Akses semua fitur Guru Kreator (Kelasku, Kreasiku dan Relungku) untuk 1 jenjang pendidikan selama 1 bulan tanpa batasan eksport dokumen (pdf).</p>
          </div>
            <b-button class="mb-3 ml-5 mr-5" style="background-color: #00AFEF; border-style:none" variant="primary rounded-pill">Berlangganan Sekarang</b-button> 
        </div>
      </div>
      <!-- end col -->
      <div class="col-xl-4">
        <div class="card"
              style= "
                      border-radius: 8px;
                      box-shadow: 1px 2px 8px rgba(0, 0, 0, 0.10);
                      margin: 0rem 1rem 1rem 1rem;
                      height: 280px;
                    "   
        >
          <div class="card-body">
              <h5 style="margin-left:10px; color:#373334" class="ml-4">Semester</h5>
              <p class="blue-paideia ml-4">100.000</p>
              <p style="color:#c6c6c6" class="ml-4"><strike>Rp 120.000</strike> Diskon 1 bulan (Rp 16.700/bulan)</p>
              <p style="color:#373334" class="ml-4">Akses semua fitur Guru Kreator (Kelasku, Kreasiku dan Relungku) untuk 1 jenjang pendidikan selama 6 bulan tanpa batasan eksport dokumen (pdf).</p>
          </div>
            <b-button class="mb-3 ml-5 mr-5" style="background-color: #00AFEF; border-style:none" variant="primary rounded-pill">Berlangganan Sekarang</b-button> 
        </div>
      </div>
      <!-- end col -->
      <div class="col-xl-4">
        <div class="card"
              style= "
                      border-radius: 8px;
                      box-shadow: 1px 2px 8px rgba(0, 0, 0, 0.10);
                      margin: 0rem 1rem 1rem 1rem;
                      height: 280px;
                    "   
        >
          <div class="card-body">
              <div class="row">
                <div class="col">
                  <h5 style="margin-left:10px; color:#373334" class="ml-4">Yearly</h5>
                </div>
                <div class="col">
                  <p class="ml-4"><img src="@/assets/images/star.png" width="20px" height="20px">Recommended</p>
                </div>
              </div>
              <p class="blue-paideia ml-4">200.000</p>
              <p style="color:#c6c6c6" class="ml-4"><strike>Rp 240.000</strike> Diskon 2 bulan (Rp 16.700/bulan)</p>
              <p style="color:#373334" class="ml-4">Akses semua fitur Guru Kreator (Kelasku, Kreasiku dan Relungku) untuk 1 jenjang pendidikan selama 1 tahun tanpa batasan eksport dokumen (pdf).</p>

          </div>
            <b-button class="mb-3 ml-5 mr-5" style="background-color: #00AFEF; border-style:none" variant="primary rounded-pill">Berlangganan Sekarang</b-button> 
        </div>
        </div>
      </div>
      <!-- end col -->

    <!-- end row -->
  </Layout>
</template>
